import ccFlywheelFeatureDiscovery from '@post-office/team-package--i18n--cc-flywheel-feature-discovery/i18n/fr.json';
import postOfficeTemplate from '@post-office/team-package--i18n--post-office-template/i18n/fr.json';
import growth from '@post-office/team-package--i18n--growth/i18n/fr.json';
import testMessages from '@post-office/team-package--i18n--test-messages/i18n/fr.json';

export default {
	...ccFlywheelFeatureDiscovery,
	...postOfficeTemplate,
	...growth,
	...testMessages
}
